import { MenuItem as MuiMenuItem, MenuItemProps, styled } from '@mui/material';

export const MenuItem = styled(MuiMenuItem)<MenuItemProps>(({ theme }) => ({
  '& .MuiListItemIcon-root > svg': {
    color: theme.palette.text.secondary,
  },
}));
